import Button from 'components/Button'
import Control from 'components/Control/Control'
import UploadIcon from 'components/icons/UploadIcon'
import React, { Fragment } from 'react'
import ErrorMessage from 'utils/ErrorMessage'

import {
  AddIcon,
  SmallButtons,
  SpanText,
  StyledH2,
  StyledUpload,
  TextWrapper,
  UploadText,
  Wrapper,
} from 'components/Uploader/Styles'
import Add from 'components/icons/Add'
import { deleteFile, uploadFile } from 'modules/Drive/actions'
import { useDispatch } from 'react-redux'

const Uploader = ({
  isDelete,
  file,
  setFile,
  isDefault = false,
  showTextUploder,
  showButtonUploder,
  fileName,
  format,
  fileURL,
  setFileURL,
  message,
  bgcolor='#fafafb',
  borderColor='#cccfd6',
  height = 'auto',
  accept = '.xlsx , .csv, .jpg, .jpeg, .png, .ppt, .doc, .pdf'
}) => {
  const dispatch = new useDispatch()

  const getFileUrl = async info => {
    let getType = info?.file?.type?.includes('xlsx') ? 'xlsx' : 'csv'
    let name = fileName + '.' + getType
    let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
    if (response) {
      setFile(response)
    }
  }

  const props = {
    name: 'file',
    multiple: false,
    listType: 'picture',
    accept: '.xlsx',
    beforeUpload: file => {
      const isLt10mb = file.size / 1024 / 1024 < 10
      if (!isLt10mb) {
        ErrorMessage('Image must smaller than 10mb!')
        return false
      } else if (!file?.type?.includes('xlsx') && !file?.type?.includes('csv')) {
        ErrorMessage(
          message ?? 'File should be in xlsx/csv/jpeg/png/ppt/doc  format!'
        )
        return false
      }
    },
    onChange: async info => {
      if (isDelete && info?.file?.status === 'done') {
        let response = await dispatch(deleteFile(file))
        if (response) {
          return getFileUrl(info)
        }
      } else if (!isDelete && info?.file?.status === 'done') {
        return getFileUrl(info)
      }
    },
    itemRender: () => {},
  }

  const dummyRequest = ({ file, onSuccess }) => {
    setTimeout(() => {
      onSuccess('OK')
    }, 0)
  }

  const onBeforeUpload = file => {
    const isLt10mb = file.size / 1024 / 1024 < 10
    if (!isLt10mb) {
      ErrorMessage('File must smaller than 10mb!')
      return false
    } else if (
      !file?.type?.includes('spreadsheetml') &&
      !file?.type?.includes('jpeg') &&
      !file?.type?.includes('jpg') &&
      !file?.type?.includes('png') &&
      !file?.type?.includes('msword') &&
      !file?.type?.includes('powerpoint') &&
      !file?.type?.includes('presentation') &&
      !file?.type?.includes('doc') &&
      !file?.type?.includes('pdf')&&
      !file?.type?.includes('csv')
    ) {
      ErrorMessage(message ?? 'File should be in xlsx/csv  format!')
      return false
    }
  }

  const onChangeFileUpload = async info => {
    if (info?.file?.status === 'done') {
      let getType = info?.file?.type?.includes('spreadsheetml')
        ? 'xlsx'
        : info?.file?.type?.includes('msword')
        ? 'doc'
        : info?.file?.type?.includes('png')
        ? 'png'
        : info?.file?.type?.includes('powerpoint')
        ? 'ppt'
        : info?.file?.type?.includes('jpg')
        ? 'jpg'
        : info?.file?.type?.includes('jpeg')
        ? 'jpeg'
        : info?.file?.type?.includes('pdf')
        ? 'pdf'
        : 'csv'
      let name = info?.file?.name
      let response = await dispatch(uploadFile(info?.file?.originFileObj, name))
      if (response) {
        let fileObject = {
          name: name,
          url: response,
          size: info?.file?.size,
          date: new Date().getTime(),
          type: getType,
        }
        setFile(file => [...file, fileObject])
        setFileURL(fileResponse => [...fileResponse, response])
      }
    }
  }
  return (
    <Fragment>
      {isDefault && (
        <Wrapper center alignCenter column bgcolor={bgcolor} borderColor={borderColor} height={height}>
          <StyledUpload
            {...props}
            type="file"
            accept={accept}
            customRequest={dummyRequest}
            onChange={onChangeFileUpload}
            beforeUpload={onBeforeUpload}
            multiple={true}
            drag
          >
            <SmallButtons
              height={'38px'}
              width="38px"
              border={true}
              icon={<UploadIcon />}
            />
            <TextWrapper>
              <StyledH2>Browse for file or Drag and drop</StyledH2>
            </TextWrapper>
            <TextWrapper>
              <SpanText>Format {format ?? ': .xlsx'}</SpanText>
            </TextWrapper>
          </StyledUpload>
        </Wrapper>
      )}
      {showTextUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Control center alignCenter top="5px">
            <AddIcon>
              <Add />
            </AddIcon>
            <UploadText>Upload File</UploadText>
          </Control>
        </StyledUpload>
      )}
      {showButtonUploder && (
        <StyledUpload {...props} type="file" customRequest={dummyRequest}>
          <Button.Primary text="Change" height={'32px'} />
        </StyledUpload>
      )}
    </Fragment>
  )
}

export default Uploader
